<div class="folder-wrapper background-white">
  <!-- the iframe will get inflated when the url is fetched  and set -->
  <iframe #myIframe width="0" height="0" style="border: none"> </iframe>
  <ng-container *ngIf="!myIframe.src">
    <div class="loading-center">
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
  </ng-container>
</div>
